import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../media-query';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextState.width >= 900 && this.state.width < 900) {
            return true;
        }

        if (nextState.width < 900 && this.state.width >= 900) {
            return true;
        }

        return false;
    }

    render() {
        if (MQ.isMobile() || MQ.isTabletPortrait()) {
            return (
                <top-nav>
                    <a href='/daily-horoscope' onClick={() => this.trackClick('Today')}>Today</a>
                    {this.renderReadingsLink()}
                    <a href='/love-and-compatibility' onClick={() => this.trackClick('Love')}>Love</a>
                    <a href='/tarot' onClick={() => this.trackClick('Tarot')}>Tarot</a>
                    <a
                        href='/psychics'
                        target='_blank'
                        rel='noopener'
                        onClick={() => this.trackClick('Psychics')}
                    >
                        Psychics
                    </a>
                </top-nav>
            );
        }

        return (<top-nav />);
    }

    renderReadingsLink = () => {
        if (this.props.logged_in) {
            return (
                <a href='/readings-reports' onClick={() => this.trackClick('Readings')}>
                    Readings
                </a>
            );
        }

        return (
            <a href='/readings-reports/tarot-readings/free' onClick={() => this.trackClick('FREE Tarot Reading')}>
                Free Tarot<br />Reading
            </a>
        );
    }

    trackClick = (label) => {
        this.props.trackEvent([
            'Navigation',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            label,
        ]);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
